/* 2026-07-28 - Joel: "all upsells on the site should look like this" (Saber Lab SPARES & EXTRAS).
   Behaviour for the shared upsell card rendered by snippets/aoam-upsell-strip.liquid.

   Two things, both ported from the Saber Lab:

   1. The plus adds to the cart. The cart write itself is add_draw_accesories_pro in assets/theme.js,
      untouched and shared with every other rail, so the warranty line properties stay identical
      everywhere. That function writes "Added" into the button and disables it, which is right for a
      full width Add button and wrong for a 20px square, so the plus is restored here: a lime filled
      check while it lands, then back to the plus.

   2. Drag to pan the rail (Joel 2026-07-27, on the Lab: "the upsell should always be able to be
      grabbed/dragged with the mouse to see options"). The cards fill the rail, so a press almost
      always lands ON one. A plain click still goes to the card; a pull past 7px becomes a 1:1 pan
      and the click that ends it is swallowed.

   Delete this file, assets/aoam-upsell-card.css and snippets/aoam-upsell-strip.liquid, then revert
   the callers listed at the top of that snippet, to roll back. */
(function () {
  if (window.__aoamUpsellCard) return;
  window.__aoamUpsellCard = true;

  /* 2026-08-11 - Joel: "improve the plus sign for adding upsell". These were the text characters
     '＋' and '✓', set with textContent. Neither is carried by Rajdhani, so both fell through to a
     system font and drew a different weight and a different optical centre on every device. Both are
     inline SVG now, on the same 24 box as the one in snippets/aoam-upsell-card.liquid, written with
     innerHTML. currentColor is black on the lime chip, and assets/aoam-upsell-card.css sizes the svg
     off the button so a rail that shrinks its plus keeps the same glyph.
     Restore the two characters and the two textContent lines below to roll back. */
  var GLYPH = function (d) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + d +
      '" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" ' +
      'stroke-linejoin="round"/></svg>';
  };
  var PLUS = GLYPH('M12 5.5v13M5.5 12h13');
  var TICK = GLYPH('M5 12.5 10 17.5 19 7');

  /* 2026-08-07 - Joel: "Safe trims only, no content removed" (page weight). The cart drawer's rail
     is in the DOM on every page but only translated off-canvas, so loading="lazy" never held its
     thumbnails back and four of them downloaded on every page load of the store (74.3 KB, 4
     requests). snippets/aoam-upsell-strip.liquid now emits those four with a data-URI placeholder
     and the real URL in data-src when defer_images is passed; this hydrates them.

     The IntersectionObserver is the primary hook because it is route-agnostic: the drawer is opened
     programmatically by add_draw_accesories_pro with no click, and it re-renders its rail on every
     cart change, so a click handler alone has a confirmed miss path. rootMargin is 0 deliberately -
     any horizontal margin would make an off-canvas drawer intersect and defeat the whole thing.
     hydrateAll() on the header trigger and before our own programmatic open is belt and braces, so
     the photo is already in flight before the drawer finishes sliding.
     Delete this block, the hydrate calls below and the defer_images branch in the snippet to roll
     back. */
  var axcImgIO = null;
  /* 2026-09-22 (Claude) - image audit. Moves data-srcset onto srcset as well as data-src onto
     src, so the deferred drawer thumbnails can be chosen per device instead of every one of
     the fifteen taking the flat 400w. Paired with snippets/aoam-upsell-card.liquid; the sizes
     attribute is plain HTML there and needs nothing here.
     ORDER MATTERS: srcset is assigned BEFORE src. A browser that has srcset already set when
     src lands picks from the candidate list; set src first and it can commit to the 400w
     fallback before the list exists, which is the whole saving thrown away.
     data-srcset is removed first so the [data-src] / [data-srcset] selectors cannot re-hydrate
     an image that is already done.
     Delete the two srcset lines to roll back, and the attributes in the snippet with them. */
  function axcHydrate(img) {
    var u = img.getAttribute('data-src');
    if (!u) return;
    var ss = img.getAttribute('data-srcset');
    img.removeAttribute('data-src');
    if (ss) { img.removeAttribute('data-srcset'); img.srcset = ss; }
    img.classList.remove('axc-img-defer');
    img.src = u;
  }
  function axcHydrateAll(root) {
    (root || document).querySelectorAll('.axc-ph img[data-src]').forEach(axcHydrate);
  }
  function axcWireImages(root) {
    var imgs = (root || document).querySelectorAll('.axc-ph img[data-src]');
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) { imgs.forEach(axcHydrate); return; }
    if (!axcImgIO) {
      axcImgIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { axcHydrate(en.target); axcImgIO.unobserve(en.target); }
        });
      }, { rootMargin: '0px' });
    }
    imgs.forEach(function (i) { axcImgIO.observe(i); });
  }
  function axcTriggerSniff(e) {
    if (e.target && e.target.closest && e.target.closest('[data-header-cart-trigger]')) axcHydrateAll();
  }
  // Both, deliberately: a real tap fires pointerdown first (earliest possible start), but a
  // synthetic .click() from other theme code fires click only.
  document.addEventListener('pointerdown', axcTriggerSniff, true);
  document.addEventListener('click', axcTriggerSniff, true);

  // Last catch, and the one that covers theme.js's AJAX add-to-cart, which calls
  // new theme.Drawer('header_minicart','right').open() with no click anywhere. Watch the drawer's
  // own class/style and hydrate the moment it is no longer parked off the right edge. Cheap: it
  // only reads a rect when an attribute on the drawer or the body actually changes.
  function axcMaybeHydrate() {
    var d = document.getElementById('header_minicart');
    if (!d) return;
    if (d.getBoundingClientRect().left < window.innerWidth - 1) axcHydrateAll();
  }
  function axcWatchDrawer() {
    var d = document.getElementById('header_minicart');
    if (!d || d.dataset.axcDrawerWatched) return;
    d.dataset.axcDrawerWatched = '1';
    var mo = new MutationObserver(axcMaybeHydrate);
    mo.observe(d, { attributes: true, attributeFilter: ['class', 'style'] });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* 2026-08-14 - Joel: "if i add something to the cart from the upsell then the item should leave
     the upsell and be replaced with next likely item the person would order. this needs to be
     udpated in all carts in all areas desktop and mobile."

     The Kit Builder and the Saber Lab already did this in their own code (stripPicks() filters on
     S.cart, and the Lab's .exstrip builder skips any part with qty > 0), and both rebuild their rail
     on every cart change. The main site was the only one that did not, because its rail is Liquid
     and nothing re-renders it after an add: add_draw_accesories_pro in assets/theme.js POSTs to
     /cart/add.js and stops there.

     So this is the client half. snippets/aoam-upsell-list.liquid is the server half - it drops
     anything already in the cart on the next render, which is what makes the removal survive a
     reload, and it queues `reserve` hidden cards for this to promote.

     Scoped to .axc-strip[data-axc-swap], which only the two cart callers set. A product page rail
     keeps the old restore-the-plus behaviour untouched.

     Removal is by HANDLE across every swap rail on the page, not by node: on the /cart page the
     drawer rail and the page rail can both be offering the same product, and they can be offering
     different variants of it, so a variant id would miss.

     Delete this block, the two lines that call it in aoamUpsellAdd, the .axc[hidden] rule in
     assets/aoam-upsell-card.css and the skip_cart / reserve params to roll back. */
  /* 2026-10-09 (Claude), Joel: "do not upsell flow art tubes on the light painting tube orders. we want
     light painters to buy the light painting tubes". While the cart holds a light painting tube, the
     saber tubes and their saber-only parts never show (axcMatch hides them, axcPromote skips them) and
     the other light painting tubes rank first. Server half: aoam_lp_on in snippets/aoam-upsell-list.liquid.
     Roll back: delete LP_TUBES, LP_FIRST, NO_FLOW, axcNoFlow, the axcNoFlow lines in axcMatch, and put
     axcPromote back to querySelector('.axc--reserve[hidden]'). */
  var LP_TUBES = { 'light-painting-tube': 1, 'butterfly-light-painting-tube': 1, 'honeycomb-light-painting-tube': 1, 'dots-combo-light-painting-tube': 1, 'spiral-dots-light-painting-tube': 1, 'pattern-tube-variety-pack': 1, 'pattern-tube-set-11-inch': 1 };
  var LP_FIRST = ['light-painting-tube', 'honeycomb-light-painting-tube', 'butterfly-light-painting-tube', 'dots-combo-light-painting-tube', 'spiral-dots-light-painting-tube'];
  var NO_FLOW = { 'sol-saber-accessory': 1, 'honeycomb-saber-accessory': 1, 'butterfly-saber-accessory': 1, 'stellar-saber-accessory': 1, 'saber-twist-on-cap': 1, 'flow-cap': 1 };
  var axcNoFlow = false;
  /* 2026-10-12 (Claude), Joel: "we cannot advertise light painting products on flow product pages. and visa versa." axcOff: a card whose data-aud (snippets/aoam-upsell-card.liquid) is the other audience from this product page (window.AOAM_PAGE_AUD, snippets/aoam-upsell-strip.liquid) is never promoted, ranked in or imported. Delete this block and its four calls to roll back. */
  function axcOff(c) { var a = c.getAttribute('data-aud'), p = window.AOAM_PAGE_AUD; return !!(p && a && a !== 'both' && p !== 'both' && a !== p); }
  function axcPromote(strip) {
    var next = null;
    strip.querySelectorAll('.axc--reserve[hidden]').forEach(function (c) { if (!next && !(axcNoFlow && NO_FLOW[c.getAttribute('data-handle')]) && !axcOff(c)) next = c; });
    if (!next) return;                       // out of reserves: the rail just gets shorter
    next.removeAttribute('hidden');
    next.classList.remove('axc--reserve');
    axcWireImages(next);                     // a drawer reserve carries data-src, not a real photo
  }
  function axcSwapOut(handle) {
    if (!handle) return;
    document.querySelectorAll('.axc-strip[data-axc-swap]').forEach(function (strip) {
      var card = null;
      var all = strip.querySelectorAll('.axc');
      for (var i = 0; i < all.length; i++) {
        // getAttribute rather than a built selector: no CSS.escape dependency, and a handle from
        // the DOM never reaches the selector parser
        if (all[i].getAttribute('data-handle') === handle && !all[i].hasAttribute('hidden')) {
          card = all[i]; break;
        }
      }
      if (!card) return;
      card.remove();                         // childList change, so axcNav's observer re-syncs the arrows
      axcPromote(strip);
      axcMute(strip);                        // 2026-08-14, see axcMute
    });
    axcMaybeHydrate();                       // an open drawer should not wait for the observer
  }

  /* 2026-09-28 cart-fix-m C13 (Claude): the client half of skip_cart. The drawer rail is Liquid rendered with the page,
     so a product added from a PDP, the sticky bar or a quick add stayed on offer, and its + quietly took that line from 1
     to 2. After every cart event the rail now drops any product already in the cart through axcSwapOut (a reserve takes
     the slot). A card whose own + is mid-add is left to aoamUpsellAdd, which swaps it after the tick.
     Rollback: delete this block. */
  var axcPruneTimer = null;
  var AXC_LIVE = '.axc-strip[data-axc-swap] .axc:not([hidden])';
  function axcPruneInCart() {
    if (!document.querySelector(AXC_LIVE)) return;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var inCart = {}, busy = {}, drop = [];
        cart.items.forEach(function (i) { if (i.handle && (+i.quantity || 0) > 0) inCart[i.handle] = true; });
        document.querySelectorAll(AXC_LIVE).forEach(function (card) {
          if (card.querySelector('.axc-add.is-loading, .axc-add.is-added')) busy[card.getAttribute('data-handle')] = true;
        });
        document.querySelectorAll(AXC_LIVE).forEach(function (card) {
          var h = card.getAttribute('data-handle');
          if (h && inCart[h] && !busy[h] && drop.indexOf(h) < 0) drop.push(h);
        });
        drop.forEach(axcSwapOut);
        axcMatch(cart);
        axcFill(cart);
      })
      .catch(function () {});
  }
  /* 2026-10-07 (Claude), Joel: "A, ship it" (cart upsell that matches the cart). The drawer rail is
     rendered with the page, usually on an empty cart, so the server order alone would only match the
     cart after a reload. After every cart event this re-ranks each rail carrying data-axc-map
     (snippets/aoam-upsell-match.liquid): the add-ons for the priciest matched product in the cart
     first, then the next one's, then everything else in its original server order. Same number of
     cards shown; the rest go back to being hidden reserves. A rail with a card mid-add is left alone,
     and nothing moves when the order already matches, so a + on the rail never reshuffles it.
     Rollback: delete this function and its one call in axcPruneInCart. */
  function axcMatch(cart) {
    document.querySelectorAll('.axc-strip[data-axc-swap][data-axc-map]').forEach(function (strip) {
      if (strip.querySelector('.axc-add.is-loading, .axc-add.is-added')) return;
      var map = {};
      strip.getAttribute('data-axc-map').split('|').forEach(function (row) {
        var p = row.split('=');
        if (p.length === 2) map[p[0].trim()] = p[1].split(',');
      });
      var inCart = {}, lines = [], want = [];
      cart.items.forEach(function (i) {
        if ((+i.quantity || 0) > 0) { inCart[i.handle] = true; if (map[i.handle]) lines.push(i); }
      });
      lines.sort(function (a, b) { return (+b.final_line_price || 0) - (+a.final_line_price || 0); });
      axcNoFlow = cart.items.some(function (i) { return (+i.quantity || 0) > 0 && LP_TUBES[i.handle]; });
      if (axcNoFlow) LP_FIRST.forEach(function (h) { want.push(h); });
      lines.forEach(function (l) {
        map[l.handle].forEach(function (h) { h = h.trim(); if (h && want.indexOf(h) < 0) want.push(h); });
      });
      var cards = Array.prototype.slice.call(strip.querySelectorAll('.axc:not(.axc--sp)')); /* 2026-10-09 the second-prop tile (snippets/aoam-second-prop.liquid) is pinned first and never ranked */
      cards.forEach(function (c, i) { if (!c.hasAttribute('data-axc-rank')) c.setAttribute('data-axc-rank', i); });
      var shown = cards.filter(function (c) { return !c.hasAttribute('hidden'); }).length;
      if (!shown) return;
      var live = cards.filter(function (c) { var h = c.getAttribute('data-handle'); return !inCart[h] && !(axcNoFlow && NO_FLOW[h]) && !axcOff(c); });
      var key = function (c) {
        var w = want.indexOf(c.getAttribute('data-handle'));
        return w >= 0 ? w : 1000 + (+c.getAttribute('data-axc-rank') || 0);
      };
      var next = live.slice().sort(function (a, b) { return key(a) - key(b); });
      var names = function (list) { return list.map(function (c) { return c.getAttribute('data-handle'); }).join(','); };
      var cur = cards.filter(function (c) { return !c.hasAttribute('hidden'); });
      if (names(cur) === names(next.slice(0, shown))) return;
      cards.forEach(function (c) { if (inCart[c.getAttribute('data-handle')]) c.remove(); });
      cards.forEach(function (c) { if (((axcNoFlow && NO_FLOW[c.getAttribute('data-handle')]) || axcOff(c)) && !inCart[c.getAttribute('data-handle')]) { c.setAttribute('hidden', ''); c.classList.add('axc--reserve'); } });
      next.forEach(function (c, i) {
        strip.appendChild(c);
        if (i < shown) { c.removeAttribute('hidden'); c.classList.remove('axc--reserve'); axcWireImages(c); }
        else { c.setAttribute('hidden', ''); c.classList.add('axc--reserve'); }
      });
      strip.scrollLeft = 0;
    });
  }
  /* 2026-10-07 (Claude), Joel: "fix the quick add gap too". A rail only carries the match rows and spare
     cards for what was in the cart (or being viewed) when the page rendered, so a quick add of anything
     else could not re-rank it until the next page load. When the cart holds a product the rail has no
     row for, this fetches /cart?view=aoam-rail (templates/cart.aoam-rail.liquid: the same drawer rail
     rendered against the new cart), merges in the rows it lacks, appends the cards it lacks as hidden
     reserves, and re-runs axcMatch. Each handle is asked about once per page, so an unmapped product
     costs one fetch, not one per cart event. Rollback: delete this function and its call. */
  var axcAsked = {};
  function axcFill(cart) {
    var strips = document.querySelectorAll('.axc-strip[data-axc-swap]:not([data-axc-swap="pdp"])'); /* 2026-10-09 product page rails swap but never take the drawer's cards */
    if (!strips.length) return;
    var have = {};
    strips.forEach(function (s) {
      (s.getAttribute('data-axc-map') || '').split('|').forEach(function (r) { var a = r.split('=')[0].trim(); if (a) have[a] = 1; });
    });
    var need = cart.items.filter(function (i) { return (+i.quantity || 0) > 0 && i.handle && !have[i.handle] && !axcAsked[i.handle]; });
    if (!need.length) return;
    need.forEach(function (i) { axcAsked[i.handle] = 1; });
    fetch('/cart?view=aoam-rail', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.axc-strip[data-axc-swap][data-axc-map]');
        if (!fresh) return;
        var rows = fresh.getAttribute('data-axc-map').split('|').filter(function (r) { return r.indexOf('=') > 0; });
        var changed = false;
        strips.forEach(function (s) {
          if (!document.contains(s)) return;
          var cur = s.getAttribute('data-axc-map') || '';
          var got = {};
          cur.split('|').forEach(function (r) { var a = r.split('=')[0].trim(); if (a) got[a] = 1; });
          var add = rows.filter(function (r) { return !got[r.split('=')[0].trim()]; });
          if (add.length) { s.setAttribute('data-axc-map', cur + '|' + add.join('|')); changed = true; }
          var mine = {}, cards = s.querySelectorAll('.axc:not(.axc--sp)');
          cards.forEach(function (c, i) {
            mine[c.getAttribute('data-handle')] = 1;
            if (!c.hasAttribute('data-axc-rank')) c.setAttribute('data-axc-rank', i);
          });
          var n = cards.length;
          fresh.querySelectorAll('.axc').forEach(function (c) {
            var h = c.getAttribute('data-handle');
            if (!h || mine[h] || axcOff(c)) return;
            mine[h] = 1;
            var k = document.importNode(c, true);
            k.setAttribute('hidden', ''); k.classList.add('axc--reserve'); k.setAttribute('data-axc-rank', n++);
            s.appendChild(k); changed = true;
          });
        });
        if (!changed) return;
        return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (c) { if (c && c.items) axcMatch(c); });
      })
      .catch(function () {});
  }
  window.axcFill = axcFill;
  window.axcMatch = axcMatch;
  window.axcSwapOut = axcSwapOut;
  ['cart:updated', 'cart:change', 'cart:quantity', 'ajaxProduct:added', 'ajaxCart:afterCartLoad'].forEach(function (ev) {
    document.addEventListener(ev, function () { clearTimeout(axcPruneTimer); axcPruneTimer = setTimeout(axcPruneInCart, 700); });
  });

  /* 2026-08-14 - Joel: "after adding an upsell item, the added product correctly loads in the cart
     and is removed from the upsell list, but the issue is the next product in the list has the +
     button highlighted."

     Removing a card shifts the ones after it left, so a card slides UNDER a pointer that never
     moved and the browser calls that a hover. It is not wrong, but a card lighting up on its own
     one beat after you pressed a different one reads as a second add, and on iOS Safari it does not
     even clear on its own: hover is held on whatever sits at the last touch point until you tap
     somewhere else.

     So the rail is muted for one beat and wakes on the next GENUINE pointer move or press. The
     listeners are added per mute and removed on the first one that fires, so there is nothing bound
     at rest. pointermove alone is not enough on touch, where a finger can leave and come back with
     no move in between, hence pointerdown as well; and the 2500ms timer is the backstop for a
     pointer that never returns at all, so a rail can never stay muted.

     The paint lives in the .axc-nohover block at the foot of assets/aoam-upsell-card.css.
     Delete this function, the axcMute call above and that CSS block to roll back. */
  function axcMute(strip) {
    if (!strip || strip.classList.contains('axc-nohover')) return;
    strip.classList.add('axc-nohover');
    var wake = function () {
      strip.classList.remove('axc-nohover');
      document.removeEventListener('pointermove', wake, true);
      document.removeEventListener('pointerdown', wake, true);
      clearTimeout(t);
    };
    var t = setTimeout(wake, 2500);
    // deferred by a frame so the very pointer event that is still in flight from the press cannot
    // wake it immediately
    requestAnimationFrame(function () {
      document.addEventListener('pointermove', wake, true);
      document.addEventListener('pointerdown', wake, true);
    });
  }

  window.aoamUpsellAdd = async function (ev, btn) {
    if (typeof window.add_draw_accesories_pro !== 'function') return;
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    // Only a rail on a PAGE needs the drawer opened afterwards. A rail INSIDE the drawer is already
    // looking at the cart, and clicking the header trigger there would toggle it shut.
    var inDrawer = !!btn.closest('#header_minicart, .site-header__drawers-container');
    var swapCard = btn.closest('.axc-strip[data-axc-swap]') ? btn.closest('.axc') : null;
    var swapHandle = swapCard ? swapCard.getAttribute('data-handle') : null;

    var pressedAt = Date.now();

    try {
      var aoamAddRes = await window.add_draw_accesories_pro(ev, btn);   // 2026-09-28 cart-fix-l low-drawer-logic C125
    } catch (e) {
      console.error(e);
    }

    /* 2026-08-16 - Joel: "in the carts i want the add button on upsell to turn green when hovered
       then show spinning wheel when pressed."

       The wheel was already DRAWN. .axc-add.is-loading has carried a scrim and a lime ring in
       assets/aoam-upsell-card.css since 2026-08-11. What it never had was time on screen: the class
       goes on immediately above and comes off the instant the cart write answers, which on a warm
       connection is well under a fifth of a second, so it flashed or never painted at all. That is
       why this reads as a missing feature rather than a broken one.

       400ms is the usual floor for a busy indicator, long enough to register as "it is working" and
       short enough not to feel like a wait we invented. It costs a slow add nothing, because by the
       time this runs the wait has already happened. The add itself is complete before this line, so
       nothing about the cart is being delayed, only the confirmation animation.

       add_draw_accesories_pro ends with button.textContent = 'Added', which swaps our SVG for a text
       node. The plus goes back first so the chip holds the same hidden glyph for the whole busy
       window as it did before the press, rather than a stray word sitting behind the wheel.
       Delete this block to roll back. */
    btn.innerHTML = PLUS;
    var spun = Date.now() - pressedAt;
    if (spun < 400) await new Promise(function (r) { setTimeout(r, 400 - spun); });

    /* 2026-08-14 second pass - Joel, with a screenshot of a 3 ITEMS drawer showing two rows and a
       void where the third should be: "i just added the bitwhip travel case and it did not go to the
       cart". It HAD gone to the cart. Subtotal $329.85 is 159.95 + 139.95 + 29.95 and the header
       said 3 ITEMS. What was missing was the ROW.

       add_draw_accesories_pro POSTs to /cart/add.js and dispatches nothing - its own
       `ajaxProduct:added` line is commented out in assets/theme.js. Every rebuild in
       snippets/aoam-cart-fix.liquid (the row render, the reconcile, the totals writer and the
       rowless healer) is wired to that event, so an add from a rail rebuilt no rows. It LOOKED fine
       whenever the added product carried a warranty, because the warranty writer dispatches the
       event itself when the warranty line changes; a travel case carries none, so nothing fired.
       That is a pre-existing hole in the rail add path, not something the swap introduced, but the
       swap made it look like a failed add rather than a slow one, because the card left too.

       Fired unconditionally: every listener re-reads /cart.js and is mismatch-gated, so firing it
       after an add that changed nothing is a no-op rather than a risk.

       ORDER MATTERS and it is not obvious. theme.js's handler is
       `buildCart(); if (!config.cartOpen) this.open();`, so the event OPENS the drawer as well as
       rebuilding it. Dispatching before the trigger click below would open the drawer and then have
       our own click TOGGLE IT SHUT. Dispatching after is safe in both directions: a second open() is
       idempotent, a second toggle is not.
       Delete this dispatch to roll back. */

    /* 2026-09-28 cart-fix-l low-drawer-logic C125: a refused add no longer paints the success tick for 1.6s before reverting. The plus stays, the button
       stays usable, and the reason is read out to screen readers (a visible message waits on Joel's design). Delete to roll back. */
    if (aoamAddRes && aoamAddRes.ok === false) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      try { if (typeof window.aoamCartAnnounce === 'function') window.aoamCartAnnounce(aoamAddRes.description || 'That item could not be added to your cart.'); } catch (e) {}
      // 2026-09-28 cart-fix-l visual-site-low C125: and shows it in the drawer notice (drawer-cart.liquid). Delete to roll back.
      try { if (inDrawer && typeof window.aoamDrawerNotice === 'function') window.aoamDrawerNotice(aoamAddRes.description || 'That item could not be added to your cart.', { silent: true }); } catch (e) {}
      return;
    }
    btn.classList.remove('is-loading');
    btn.classList.add('is-added');
    btn.innerHTML = TICK;

    if (!inDrawer) {
      axcHydrateAll();
      var trigger = document.querySelector('[data-header-cart-trigger]');
      if (trigger) trigger.click();
    }

    /* 2026-11-03 cart audit B-011 (Claude, W1a): the ajaxProduct:added dispatch that sat here moved into the writer,
       add_draw_accesories_pro in assets/theme.js, which now fires it once per successful add with detail.source 'rail'.
       Firing it here as well would rebuild the drawer twice per add. The order note above no longer bites: the header
       cart trigger click now runs openCartDrawer() in assets/aoam-cart-fix.js, an open and never a toggle.
       Roll back: put back  try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: {} })); } catch (e) {}
       here AND delete the B-011 dispatch in add_draw_accesories_pro. */

    /* The card may only leave the rail if the line is REALLY in the cart. btn.disabled alone is not
       proof: add_draw_accesories_pro sets it after `await response.json()`, and a 422 from
       /cart/add.js is still valid JSON, so a rejected add disables the button exactly like a
       successful one. Ask the cart instead, and fall back to the button when /cart.js cannot be
       read so a network blip leaves the rail as it was rather than silently eating a card. */
    var variantId = btn.getAttribute('data-variant-id');
    var inCart = btn.disabled === true;

    /* 2026-08-17 - READ IT TWICE BEFORE BELIEVING A NEGATIVE. cardLeftRail went red on 4 of the last
       6 gate runs, including one where every other check on that viewport passed and cleanup answered
       200, so it was neither the bot wall alone nor the 400ms wheel floor (it also failed before that
       floor shipped). One /cart.js, issued the instant the add returns, decided whether the card was
       allowed to leave. When that single read is answered with a challenge page or with a
       session-reset empty cart, this reads "not in the cart" and the card correctly-but-wrongly stays
       put - while every later read in the same session succeeds, which is why the checker sees
       addLanded and rowsMatchCart pass on the very add it grades as a stuck rail.

       A second read costs one request only in the case that was previously a silent failure, and
       nothing at all when the first read is right. A genuinely rejected add still reads "not in cart"
       twice, so the guard this replaces keeps its whole point: btn.disabled is NOT proof, because a
       422 from the cart write is still valid JSON and disables the button exactly like a success.

       Only a read that actually PARSED may overrule the button's own guess. Previously any throw left
       inCart at whatever it happened to be; now a non-ok response or an unparseable body is treated
       as no evidence, which is what it is.
       Delete this block and restore the single try/fetch to roll back. */
    for (var confirmTries = 0; confirmTries < 2; confirmTries++) {
      if (confirmTries) await new Promise(function (r) { setTimeout(r, 500); });
      var seen = null;
      try {
        var res = await fetch('/cart.js', { cache: 'no-store' });
        if (res.ok) seen = await res.json();
      } catch (e) { /* no evidence either way, leave the button-derived guess alone */ }
      if (!seen || !seen.items) continue;
      inCart = seen.items.some(function (i) { return String(i.id) === String(variantId); });
      if (inCart) break;
    }

    // 900ms on a swap rail rather than 1600: long enough to read the tick as confirmation, short
    // enough that the card leaving still feels like a consequence of the press. The plus is never
    // restored there, because the button goes with the card.
    setTimeout(function () {
      if (swapHandle && inCart) { axcSwapOut(swapHandle); return; }
      btn.disabled = false;
      btn.classList.remove('loading', 'is-added');
      btn.innerHTML = PLUS;
    }, (swapHandle && inCart) ? 900 : 1600);
  };

  /* 2026-08-10 - Joel: "it should be easier to scroll these upsells. currently when you grab to drag
     the mouse sticks to the product."

     The card photo is an <a> wrapping an <img> and both are natively draggable, so pressing on one
     and pulling started an HTML5 drag instead of a pan: the browser took the pointer, painted a ghost
     of the product under the cursor and stopped sending pointermove, so the pan below never reached
     its 7px threshold. The rail sat still while the picture followed the mouse. Nothing was wrong
     with the pan, it was never allowed to run. The Saber Lab rail this card was ported from never hit
     it, because its cards are <button> elements with no link and no image to drag.

     Three parts, and all three are needed:
       1. dragstart is cancelled on the rail (in wire below). This is the actual fix, and it is done
          in JS rather than with -webkit-user-drag alone because Firefox ignores that property.
       2. the rail carries .axc-panning for the whole press, so a pull cannot paint a text selection
          across the card names on the way past. It goes on at pointerdown, not at the threshold,
          because the browser starts selecting before 7px.
       3. the pointer is captured once panning starts, so a fast pull that leaves the rail keeps
          panning instead of dropping the gesture. Capture is deliberately NOT taken at pointerdown,
          which would sit between a press and the plus button's own click.
     Delete this block, the .axc-panning rules in assets/aoam-upsell-card.css and the dragstart
     listener in wire to roll back. */
  function railPanDown(e, host) {
    if (e.button !== 0) return;
    var sx = e.clientX, sy = e.clientY, s0 = host.scrollLeft, panning = false;
    var pid = e.pointerId;
    var swallow = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
    host.classList.add('axc-panning');
    var move = function (e2) {
      if (e2.pointerId !== pid) return;
      if (!panning) {
        if (Math.hypot(e2.clientX - sx, e2.clientY - sy) <= 7) return;
        panning = true;
        document.body.style.cursor = 'grabbing';
        try { host.setPointerCapture(pid); } catch (err) {}
        host.addEventListener('click', swallow, true);
      }
      host.scrollLeft = s0 - (e2.clientX - sx);
    };
    var up = function (e2) {
      if (e2 && e2.pointerId !== undefined && e2.pointerId !== pid) return;
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
      window.removeEventListener('pointercancel', up);
      host.classList.remove('axc-panning');
      document.body.style.cursor = '';
      try { host.releasePointerCapture(pid); } catch (err) {}
      if (panning) setTimeout(function () { host.removeEventListener('click', swallow, true); }, 0);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
  }

  /* 2026-08-10 - Joel: "make slider bar here more obvious and give another option for scroll...
     maybe arrows?"

     The rail already scrolled by wheel, swipe and drag, but nothing on screen said so. The bar is now
     a lime slider (assets/aoam-upsell-card.css) and these are the arrows.

     An arrow is shown only while there is somewhere to go in that direction, so a rail that fits
     shows neither and an end of travel drops the one that would do nothing. That is also why the
     buttons ship with the hidden attribute: until this has measured, showing them would be a lie, and
     with JS off they never appear at all.

     The step keeps one card of context rather than paging a clean screenful, which is how you stay
     oriented in a rail whose cards are all product photos. Measured from the live gap and card width
     instead of the CSS variable, because .axc grows into spare width.

     sync runs on scroll (passive), on resize, and whenever the strip's own contents change. The cart
     drawer re-renders its rail on every cart change, so the last one is not optional.

     Delete this block, the axcNav call in wire, the .axc-nav rules in assets/aoam-upsell-card.css and
     the two buttons in snippets/aoam-upsell-strip.liquid to roll back. */
  function axcNav(strip, cardSel, navWrap) {
    // 2026-08-10 second pass: the chips live on the rail's top row now, not over the cards, so the
    // lookup climbs to .axc-rail. navWrap is passed directly for the Saber Lab, whose rail has no
    // .axc-rail ancestor because it is built by the minified saber-lab.js.
    var wrap = navWrap || (strip.closest('.axc-rail') || strip.parentElement || document).querySelector('.axc-navs');
    if (!wrap) return;
    var prev = wrap.querySelector('.axc-nav--prev');
    var next = wrap.querySelector('.axc-nav--next');
    if (!prev || !next) return;

    function sync() {
      var max = strip.scrollWidth - strip.clientWidth;
      // 2px, not 0: a fractional card width leaves sub-pixel slack at either end that is not scroll
      var scrollable = max > 2;
      // the PAIR hides when there is nothing to scroll at all; at an end of travel the chip is only
      // disabled, because hiding one of a mounted pair shifts the other sideways
      wrap.hidden = !scrollable;
      prev.disabled = !scrollable || strip.scrollLeft <= 2;
      next.disabled = !scrollable || strip.scrollLeft >= max - 2;
    }

    function step() {
      var card = strip.querySelector(cardSel || '.axc');
      if (!card) return Math.round(strip.clientWidth * 0.8);
      var gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
      var one = card.getBoundingClientRect().width + gap;
      var fit = Math.floor((strip.clientWidth + gap) / one);
      return Math.round(Math.max(1, fit - 1) * one);
    }

    function go(dir) {
      var d = step() * dir;
      if (typeof strip.scrollBy === 'function') strip.scrollBy({ left: d, behavior: 'smooth' });
      else strip.scrollLeft += d;
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    strip.addEventListener('scroll', sync, { passive: true });
    // the observer covers a window resize too, and unlike a window listener it goes away with the
    // rail. The cart drawer replaces its rail on every cart change, so that matters here.
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(strip);
    else window.addEventListener('resize', sync);
    new MutationObserver(sync).observe(strip, { childList: true });
    sync();
    // a deferred thumbnail arriving can change nothing here, but a font or an image that has not
    // laid out yet can, and the drawer measures 0 wide until it has finished sliding in
    setTimeout(sync, 400);
  }

  /* 2026-08-10 - Joel, of the Kit Builder's copy of this rail: "theres no option to navigate those
     other than the bottom scroller. check the main site for more features in this". The Saber Lab's
     SPARES & EXTRAS rail is the card this whole component was ported FROM, and it never got the
     arrows either. Its markup is built by assets/saber-lab.js, which is minified and rebuilds the
     rail on every part change, so the .axc-scroller host and the two buttons are injected here
     rather than in that file. Idempotent: a rail already sitting in a scroller is returned as is,
     and a rebuild simply gets wrapped again. The Lab supplies its own drag-pan, so railPanDown is
     deliberately NOT attached here.
     Delete this function, the .exstrip loop in wire and the .exstrip rules in
     assets/aoam-upsell-card.css to roll back. */
  function excWrap(strip) {
    if (!strip.parentNode) return null;
    var prevEl = strip.previousElementSibling;
    if (prevEl && prevEl.classList.contains('axc-navs')) return prevEl;
    if (prevEl && prevEl.querySelector && prevEl.querySelector('.axc-navs')) return prevEl.querySelector('.axc-navs');
    var wrap = document.createElement('span');
    wrap.className = 'axc-navs axc-navs--ex';
    wrap.hidden = true;
    // Put the pair ON the Lab's own "Spares & extras" heading line when there is one, so all three
    // rails read the same. The guard is deliberately narrow: the element immediately before the rail
    // counts as that heading only if it is a bare text node holder (no child elements) with a short
    // label, which is exactly what saber-lab.js emits and nothing else nearby is.
    var head = prevEl && prevEl.children.length === 0
      && prevEl.textContent.trim().length > 0 && prevEl.textContent.trim().length <= 40
      ? prevEl : null;
    ['prev', 'next'].forEach(function (d) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'axc-nav axc-nav--' + d;
      b.disabled = true;
      b.setAttribute('aria-label', 'Scroll spares and extras ' + (d === 'prev' ? 'left' : 'right'));
      b.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">'
        + '<path d="' + (d === 'prev' ? 'M15.5 4.5 8 12l7.5 7.5' : 'M8.5 4.5 16 12l-7.5 7.5')
        + '" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      wrap.appendChild(b);
    });
    if (head) {
      head.classList.add('axc-exhead');
      head.appendChild(wrap);
    } else {
      strip.parentNode.insertBefore(wrap, strip);
    }
    return wrap;
  }

  /* 2026-08-11 - Joel, checking the plus restyle: "and it works correctly on desktop and mobile in
     all areas main site, kit builder, and saber builder?" It did not. The Saber Lab's three add
     controls still drew a TEXT plus, and two of the three used the fullwidth character U+FF0B, the
     exact glyph the main-site card was moved off because no font the store loads carries it.

     The Lab's markup is built by the minified assets/saber-lab.js and rebuilt on every part change,
     and sections/saber-lab.liquid forbids hand-editing the bundle, so the swap is done here - the
     same route excWrap already uses to give that rail its arrows. Idempotent: a control that already
     holds an svg is skipped, and the MutationObserver at the foot of this file re-runs it after a
     rebuild.

     The .aoam-svg-plus class is what unhides the pixel-size text in assets/saber-lab.css. It is only
     added once the swap has actually happened, so if this script ever fails to load the Lab keeps a
     visible text plus on a lime chip instead of a blank lime square.

     The Kit Builder is deliberately NOT covered: layout/kit-builder.liquid loads neither this file
     nor theme.css, and its add controls are worded buttons ("+ Add"), not plus chips, so they are a
     different component rather than a stale copy of this one.
     Delete this function and its call in wire() to roll back. */
  var LAB_ADDS = '.exc b span, .schip .sft .sadd, .chip .cadd';
  function aoamLabPlus(root) {
    (root || document).querySelectorAll(LAB_ADDS).forEach(function (el) {
      if (el.querySelector('svg')) return;
      var t = (el.textContent || '').trim();
      if (t !== '+' && t !== '＋') return;   // never touch a control that says something else
      el.innerHTML = PLUS;
      el.classList.add('aoam-svg-plus');
    });
  }

  function wire(root) {
    axcWireImages(root);
    axcWatchDrawer();
    aoamLabPlus(root);
    (root || document).querySelectorAll('.axc-strip').forEach(function (strip) {
      if (strip.dataset.axcWired) return;
      strip.dataset.axcWired = '1';
      // 2026-08-10 - the one line that stops the product image following the mouse. See railPanDown.
      strip.addEventListener('dragstart', function (e) { e.preventDefault(); });
      // touch already pans a scroll container natively; this is the mouse affordance only
      strip.addEventListener('pointerdown', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        railPanDown(e, strip);
      });
      axcNav(strip, '.axc');
    });
    (root || document).querySelectorAll('.exstrip').forEach(function (strip) {
      if (strip.dataset.axcWired) return;
      strip.dataset.axcWired = '1';
      var wrap = excWrap(strip);
      if (wrap) axcNav(strip, '.exc', wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wire(); });
  } else {
    wire();
  }

  // The cart drawer re-renders its rail on every cart change, so newly injected strips need wiring.
  /* 2026-09-28 (Claude), Joel: "fix the upsell script layout churn". This observer watches the whole
     document, so every node any app inserts (Judge.me, Klaviyo, web pixels) re-ran wire(), i.e. four
     document-wide querySelectorAll passes: 113 runs and 0.43s during one Critter PDP load at 4x CPU
     throttle. Now it only wires when an added element can hold something wire() cares about, and at
     most once per animation frame. Roll back: restore the plain loop that called wire() on any
     addedNodes.length. */
  var WIRE_SEL = '.axc-strip, .exstrip, .axc-ph img[data-src], ' + LAB_ADDS + ', #header_minicart';
  var wirePending = false;
  function wireSoon() {
    if (wirePending) return;
    wirePending = true;
    (window.requestAnimationFrame || setTimeout)(function () { wirePending = false; wire(); });
  }
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var el = added[j];
        if (el.nodeType !== 1) continue;
        if ((el.matches && el.matches(WIRE_SEL)) || (el.querySelector && el.querySelector(WIRE_SEL))) { wireSoon(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* 2026-10-12 audit R (Joel approved mockup R): the + on a rail card with options (.axc--pick, snippets/aoam-upsell-card.liquid) never adds blind. It opens the quick look from assets/aoam-addon-cards.js, which the cart drawer only loads on some pages, so this loads it on demand (URLs from window.AOAM_QL_ASSETS, printed by snippets/aoam-upsell-strip.liquid). When the quick look is already there its own capture handler takes the click and this one steps aside. Roll back: delete this block. */
(function () {
  var loading = false;
  function whenReady(cb, n) {
    if (window.aoamQlOpen) return cb();
    if ((n || 0) > 100) { loading = false; return; }
    setTimeout(function () { whenReady(cb, (n || 0) + 1); }, 60);
  }
  document.addEventListener('click', function (e) {
    var add = e.target && e.target.closest && e.target.closest('.axc--pick .axc-add');
    if (!add) return;
    if (window.aoamQlOpen) return;
    var card = add.closest('.axc--pick');
    e.preventDefault(); e.stopPropagation();
    if (loading || !card) return;
    loading = true;
    var A = window.AOAM_QL_ASSETS || {};
    if (A.css && !document.querySelector('link[href="' + A.css + '"]')) {
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = A.css; document.head.appendChild(l);
    }
    if (A.js && !document.querySelector('script[src="' + A.js + '"]')) {
      var s = document.createElement('script'); s.src = A.js; document.head.appendChild(s);
    }
    whenReady(function () { loading = false; window.aoamQlOpen(card); });
  }, true);
})();
